import _ from 'lodash';
import localStorageUtils from 'utils/localStorageUtils';

const proxyPath = process.env.PROXY_PATH;

const paramsConstructor = params => {
  return _.keys(params)
    .filter(k => params[k] !== undefined)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&');
};

export const constructUrl = (path, params = {}, options = {}) => {
  const lang = localStorageUtils.getItem('lang');
  const referer = window.__MEGOGO__referer__ || undefined;
  return [
    `/${proxyPath}/${path}?${paramsConstructor({ lang, referer, ...params })}`,
    {
      ...options,
      credentials: 'same-origin',
    },
  ];
};

export const constructPostUrl = (path, params = {}, body = {}, options = {}) => {
  const _options_ = {
    ...options,
    body: paramsConstructor(body),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(options.headers || {}),
    },
    method: 'POST',
  };

  return constructUrl(path, params, _options_);
};

const urlConstructor = {
  // GET
  getStream: ({ video_id, drm_type }) =>
    constructUrl('stream', { video_id, drm_type }),
  getStreamVirtual: ({ video_id, drm_type, virtual_id, timestamp }) =>
    constructUrl('stream/virtual', {
      video_id,
      drm_type,
      virtual_id,
      timestamp,
    }),
  getVideoInfo: ({ id, options }) =>
    constructUrl('video/info/details', {
      id,
      ...options,
      include: ['history', 'series', 'purchase_data'],
    }),
  getEpisodes: ({ id }) => constructUrl('video/episodes', { id }),
  getUser: () => constructUrl('user'),
  getConfiguration: ({ id }) => constructUrl('configuration', { id }),
  getTranslate: () =>
    constructUrl('configuration/interface', { place: 'embed_new' }),
  getPaymentsSystem: () => constructUrl('configuration/payment/systems'),
  getSubscriptionInfo: () => constructUrl('subscription/info'),
  getVideoCollection: ({ id }) => constructUrl('video/collection', { id }),
  getUserHistory: id =>
    constructUrl('user/history', { video_ids: id, limit: 1 }),
  getEpgTime: () => constructUrl('epg/time'),
  getEpgCurrent: ({ channel_id }) =>
    constructUrl('epg/current', { channel_id }),
  getEpg: ({ channel_id, from, to }) =>
    constructUrl('epg/', { channel_id, from, to }),
  getChannels: () => constructUrl('tv/channels/grouped'),
  // POST
  postAuth: ({ login, password, rememberMe }) =>
    constructPostUrl(
      'auth/login/any',
      {},
      {
        login,
        password,
        remember_me: rememberMe ? true : undefined,
      },
    ),
  postRegistration: ({ login, password, verification_code, captcha }) =>
    constructPostUrl(
      'auth/register/any',
      {},
      {
        login,
        password,
        verification_code,
        captcha,
      },
    ),
  postLogout: () => constructUrl('auth/logout'), // вообще должно быть постом, но при посте почему-то апи возвращает ошибку
  postRestore: ({ login, password, verification_code, captcha }) =>
    constructPostUrl(
      'auth/restore/any',
      {},
      {
        login,
        password,
        verification_code,
        captcha,
      },
    ),
  postCardEncrypt: data => constructPostUrl('cards/encrypt', {}, data),
};

export default urlConstructor;
